module.exports = __webpack_public_path__ + "static/media/heatBlock-bench.3bdf0ec9.svg";